<template>
  <div class="component-container" style="font-family: inherit; position: relative;min-width: 100%;">
    <div class="form-floating component-form-container">
      <input 
          v-model="searchText"
          :class="['form-control', formData.fields[fieldName].class]"
          @input="updateMatchingValues"
          @blur="validateAndSelectFirst"
          @focus="inToInput"
          :name="name"
          :id="formData.fields[fieldName].id"
          :required="formData.fields[fieldName].required"
          :disabled="formData.fields[fieldName].readonly === true"
          autocomplete="new-password"
          list="cityOptions"
          :placeholder="['Escribe una ', formData.fields[fieldName].label]"
      />
      <label :for="formData.fields[fieldName].id">{{ formData.fields[fieldName].label }}</label>
      <div @click="clearInput"><i class="fas fa-times clear-input"></i></div>
      <div v-show="isLoading" class="loading-icon"><i class="fas fa-cog fa-spin"></i></div>
      <div class="dropdown-icon"><i class="fas fa-caret-down"></i></div>

      <!-- Usamos el datalist nativo sin restricciones -->
      <datalist id="cityOptions">
        <option v-for="(city, index) in matchingValues" :key="index" :value="city.nombre">
          {{ city.nombre }}
        </option>
      </datalist>
    </div>
    <div v-if="formData.fields[fieldName].msg" class="helpMessage" style="width: 100%;">
      <p style="text-align: justify; margin: 0;" v-html="formData.fields[fieldName].msg"></p>
    </div>
  </div>
</template>

<script>
export default {
  props: {
    fieldData: { type: Object, required: true },
    formValues: { type: Object },
    formData: { type: Object, required: true },
    fieldName: { type: String, required: true },
    name: { type: String }
  },
  data() {
    return {
      searchText: this.fieldData || '',
      matchingValues: [], // Aquí almacenaremos las ciudades que coincidan
      showList: false,
      isLoading: false,
      lastSearch: "",
    };
  },
  mounted() {
    if (this.formValues.city && this.formValues.state) {
      const city = window.cities.find(
        (c) => c.city == this.formValues.city && c.state === this.formValues.state
      );
      if (city) {
        this.searchText = city.nombre;
      }
    }
  },
  methods: {
    updateMatchingValues() {
      this.isLoading = true;
      this.matchingValues = window.cities.filter(city =>
        city.nombre.toLowerCase().includes(this.searchText.toLowerCase())
      );
      this.isLoading = false;
    },
    validateAndSelectFirst() {
      // Si no hay coincidencias, limpiar la entrada
      if (this.matchingValues.length === 0) {
        this.clearInput();
      } else {
        // Si hay coincidencias pero no es exacto, seleccionar la primera opción
        const exactMatch = this.matchingValues.find(city => city.nombre.toLowerCase() === this.searchText.toLowerCase());
        if (!exactMatch) {
          this.searchText = this.matchingValues[0].nombre;
          this.selectCity(this.matchingValues[0],this.searchText);
        } else {
          this.selectCity(exactMatch,this.searchText);
        }
      }
    },
    
    selectCity(city,city_text) {
                // eslint-disable-next-line 
        debugger;

      const selected = city;
      const cityData = {};
      const field_ = this.formData.fields[this.fieldName];
      if (field_.set) {
        for (const field in field_.set) {
            cityData[field] = selected[field_.set[field]]
        }
        this.searchText = selected.city
      }
      else cityData[this.this.fieldName] = city_text;
      this.$emit('input-change', cityData);
    },
    clearInput() {
      this.searchText = '';
      this.$emit('input-change', { city: '', state: '' });
    },
    inToInput() {
      if (this.matchingValues.length > 0) {
        this.showList = true;
      }
      if (this.searchText.length >= 3 && this.lastSearch !== this.searchText) {
        this.updateMatchingValues();
      }
    }
  }
};
</script>

<style scoped>
.clear-input {
  position: absolute;
  right: 10px;
  top: 50%;
  transform: translateY(-50%);
  cursor: pointer;
  color: #ccc;
}

.clear-input:hover {
  color: #666;
}

.loading-icon {
  position: absolute;
  right: 30px;
  top: 50%;
  transform: translateY(-50%);
  color: #999;
}

.dropdown-icon {
  position: absolute;
  right: 10px;
  top: 50%;
  transform: translateY(-50%);
  cursor: pointer;
  color: #999;
}

.dropdown-icon i {
  font-size: 1.2em;
}

.dropdown-icon:hover {
  color: #666;
}
</style>
